<template>

	<div class="text-center ml-2 mr-2" v-html="text"></div>

  
<!--   <span class="ka-text">   	
    TEXT ** {{text}}   
  </span> -->
</template>

<script>
export default {
  name: 'ka-text',
  props: {
    text: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
